export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand">
      <img src="/brand/enshield-mark-64.png" width={28} height={28} alt="" aria-hidden="true" className="brand__mark" />
      {compact ? null : <span>Enshield</span>}
    </span>
  );
}

const socialLinks = [
  { name: 'Facebook', href: 'https://facebook.com/enshield', path: 'M14 8.5h2.5V5.3c-.43-.06-1.9-.19-3.6-.19-3.57 0-6 2.24-6 6.35v3.04H3.5V18h3.4v10h4V18h3.26l.52-3.5H10.9v-2.6c0-1.01.27-1.7 1.72-1.7Z' },
  { name: 'X', href: 'https://x.com/enshield', path: 'M6 5h3.7l4.2 5.6L18.8 5H21l-6.1 7.3L21.6 21H17.9l-4.6-6.1L7.6 21H5.4l6.6-7.8L6 5Z' },
  { name: 'LinkedIn', href: 'https://linkedin.com/company/enshield', path: 'M6.94 8.5A2.06 2.06 0 1 1 6.94 4.4a2.06 2.06 0 0 1 0 4.1ZM5 10.6h3.9V21H5V10.6Zm6.3 0h3.73v1.42h.05c.52-.94 1.79-1.93 3.68-1.93 3.94 0 4.66 2.53 4.66 5.82V21h-3.9v-4.65c0-1.11-.02-2.53-1.54-2.53-1.55 0-1.79 1.2-1.79 2.45V21h-3.9V10.6Z' },
  { name: 'Instagram', href: 'https://instagram.com/enshield', path: 'M12.5 4.5c2.44 0 2.73.01 3.69.05 2.47.11 3.62 1.28 3.73 3.73.04.96.05 1.25.05 3.69s-.01 2.73-.05 3.69c-.11 2.45-1.26 3.62-3.73 3.73-.96.04-1.25.05-3.69.05s-2.73-.01-3.69-.05c-2.48-.11-3.62-1.29-3.73-3.73-.04-.96-.05-1.25-.05-3.69s.01-2.73.05-3.69C5.18 5.83 6.33 4.66 8.81 4.55c.96-.04 1.25-.05 3.69-.05Zm0-1.65c-2.48 0-2.79.01-3.77.06-3.25.15-5.05 1.94-5.2 5.2-.05.98-.06 1.29-.06 3.77s.01 2.79.06 3.77c.15 3.25 1.94 5.05 5.2 5.2.98.05 1.29.06 3.77.06s2.79-.01 3.77-.06c3.25-.15 5.05-1.94 5.2-5.2.05-.98.06-1.29.06-3.77s-.01-2.79-.06-3.77c-.15-3.25-1.94-5.04-5.2-5.2-.98-.05-1.29-.06-3.77-.06Zm0 4.46a4.57 4.57 0 1 0 0 9.14 4.57 4.57 0 0 0 0-9.14Zm0 7.54a2.97 2.97 0 1 1 0-5.94 2.97 2.97 0 0 1 0 5.94Zm4.75-7.72a1.07 1.07 0 1 1-2.14 0 1.07 1.07 0 0 1 2.14 0Z' },
];

export function SocialLinks() {
  return (
    <div className="footer-social" aria-label="Enshield on social media">
      {socialLinks.map((s) => (
        <a key={s.name} href={s.href} target="_blank" rel="noreferrer" aria-label={s.name}>
          <svg viewBox="0 0 25 25" aria-hidden="true"><path d={s.path} fill="currentColor" /></svg>
        </a>
      ))}
    </div>
  );
}
